import React from 'react';
import c from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import s from './PopoverRootLayout.scss';

export interface Props {
  /** A slot at the start of the component. */
  header: React.ReactNode;

  /** A slot below `header` and before `content`. This is rendered before the header border if the border is requested */
  preamble?: React.ReactNode;

  /** A slow below `header` and `preamble`, but above `footer` */
  content: React.ReactNode;

  /** A slot below `content`, at the end of the layout */
  footer: React.ReactNode;
  className?: string;
  contentClassName?: string;

  /** Will show a border below the header + preamble but before the content */
  showHeaderBorder?: boolean;

  /** Will show a border below the content and before the footer */
  showFooterBorder?: boolean;
}

/** Our standard Popover layout, included at the root of the content. */
const PopoverRootLayout: React.FC<Props> = ({
  header,
  preamble,
  content,
  footer,
  className,
  contentClassName,
  showHeaderBorder,
  showFooterBorder,
}) => (
  <Section className={c(s['root'], className)}>
    <div className={c(s['header-and-preamble-wrapper'], showHeaderBorder && s['border'])}>
      <div className={s['header-wrapper']}>{header}</div>
      {
        // No need for a wrapper, the spec doesn't have defined paddings for this guy.
        // We'll rely on the consumer to lay this out right.
        preamble
      }
    </div>
    <div className={c(s['content-wrapper'], !footer && s['no-footer'], contentClassName)}>
      {content}
    </div>
    {footer && (
      <div className={c(s['footer-wrapper'], showFooterBorder && s['border'])}>{footer}</div>
    )}
  </Section>
);
PopoverRootLayout.displayName = 'PopoverRootLayout';

export default PopoverRootLayout;
